// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"31d6cfe0","340":"aa8c06cb"}[chunkId] + ".chunk.css";
};